import styled from 'styled-components';
import { pxToRems } from '@awaze/design-system.utils.react';
export const UspListStyled = styled.div `
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;

  > * {
    margin: 0 ${pxToRems(4)} ${pxToRems(4)} 0px;
  }
`;
//# sourceMappingURL=usp-list.styles.js.map